






















































import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from 'vuex-class'
import AppRelease from '@/modules/app-router/model/AppRelease'
import ReleaseChange, {ChangeType} from '@/modules/app-router/model/ReleaseChange';
import {VDataTableOptions} from '@/types';
import ChangeDetail from '@/modules/app-router/components/Changes/ChangeDetail.vue';

/**
 * Lista de cambios
 *
 * Muestra una lista con todos los cambios declarados en la distribución seleccionada
 * por el usuario.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ChangeDetail},
})
export default class ChangeList extends Vue {
    /**
     * Distribución actualmente seleccionada por el usuario
     *
     * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
     */
    @State(state => state.appRouter.release)
    public release: AppRelease

    /**
     * Opciones para el iterador, el componente de Vuetify encargado de mostrar
     * la lista de cambios
     */
    public options: Partial<VDataTableOptions> = {
        sortBy: ['type'],
    }

    /**
     * Termino de búsqueda de cambios
     */
    public changeSearch = ''

    /**
     * Controla la visibilidad de la pantalla para la edición de un cambio.
     */
    public changeDetail = false

    /**
     * Controla la visibilidad del menu de búsqueda
     */
    public searchMenu = false

    /**
     * Tipos de cambios y su configuración para ser mostrados en el componente.
     */
    public changeTypes = {
        [ChangeType.Added]: { text: 'Añadido', color: 'green' },
        [ChangeType.Changed]: { text: 'Modificado', color: 'blue' },
        [ChangeType.Deprecated]: { text: 'Obsoleto', color: 'yellow' },
        [ChangeType.Removed]: { text: 'Eliminado', color: 'red' },
        [ChangeType.Security]: { text: 'Seguridad', color: 'orange' },
        [ChangeType.Fixed]: { text: 'Corrección', color: 'pink' },
    }

    /**
     * Método invocado cuando el usuario pulsa el botón "Añadir" o sobre la tarjeta
     * un cambio. Establece el cambio argumentado como cambio actualmente
     * en edición. Si no se argumenta ningún cambio, se creará un
     * nuevo.
     *
     * @param change
     */
    public editChange (change: ReleaseChange | null = null) {
        this.$store.commit('appRouter/SET_CURRENT_CHANGE', change)
        this.changeDetail = true
    }
}
